module.exports = __webpack_public_path__ + "img/card-pos.fb9b1d73.svg";